import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import {
  clientNameSelector,
  userSelector,
  currentGroupSelector,
} from 'store/modules/auth';
import { newCampaign, fetchCampaigns, campaignsSelector } from '../modules';
import Home from '../components/Home';
import { ROLES } from '../../../../consts';

const mapStateToProps = createStructuredSelector({
  campaigns: campaignsSelector,
  clientName: clientNameSelector,
  user: userSelector,
  currentGroup: currentGroupSelector,
});

const mapDispatchToProps = dispatch => ({
  newCampaign() {
    dispatch(newCampaign);
  },
  fetchCampaigns() {
    dispatch(fetchCampaigns());
  },
});

const enhance = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {
      this.props.history.push('/dashboard');
      this.props.fetchCampaigns();
    },
    componentDidUpdate() {
      const { myRoles } = this.props.currentGroup;

      if (!myRoles.includes(ROLES.CMS) && !myRoles.includes(ROLES.SUPERADMIN)) {
        this.props.history.push('/dashboard');
      }
    },
  })
);

export default enhance(Home);
